import News from "/components/side/news";
import InstallCenters from "/components/side/installCenters";
import RightSide from "../../components/layouts/rightSide";
import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import { useSelector, useDispatch } from "react-redux";
import styles from "./index.module.scss";
import Botton from "/components/common/button";
import Link from "next/link";
import { useRouter } from "next/router";
import { popupTypes } from "/redux/reducers/popupReducer";
import { showPopup } from "/redux/action-creaters/popup";
import { fetchRightNews } from "/redux/action-creaters/content";
import Redis from "/lib/redis";
import pagesWrapper from "../../utils/pagesWrapper";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { Api } from "../../api";
import Breadcrumbs from "../../components/common/breadcrumbs";

export default function ServicesPage({ services, scripts, host, isFarkop }) {
  const { cityName } = useSelector((state) => state.location);
  const router = useRouter();
  const dispatch = useDispatch();

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      {!["msk.farkop.ru", "spb.farkop.ru"].includes(host) && (
        <div className="container">
          <Breadcrumbs />
          <div className={styles.Empty}>
            <h1>
              {cityName === "Россия" ? (
                <>Уважаемый клиент</>
              ) : (
                <>
                  Уважаемый клиент, мы не оказываем услуги по установке и
                  регистрации фаркопов и электрики в городе {cityName}
                </>
              )}
            </h1>
            <div>
              {cityName === "Россия" ? (
                <>
                  Выберите ближайший к вам город для записи на установку или
                  регистрации фаркопа:
                </>
              ) : (
                <>
                  Мы работаем над открытием установочного центра в вашем городе,
                  но вы можете выбрать ближайший к вам город для записи на
                  установку или регистрации фаркопа:
                </>
              )}
            </div>
            <div className={styles.EmptyLinks}>
              <Link href={"https://spb.farkop.ru/services/"}>
                <a>Санкт-Петербург</a>
              </Link>
              <Link href={"https://msk.farkop.ru/services/"}>
                <a>Москва</a>
              </Link>
            </div>
          </div>
        </div>
      )}
      {["msk.farkop.ru", "spb.farkop.ru"].includes(host) && (
        <RightSide
          title="Услуги"
          side={
            <>
              <InstallCenters isFarkop={isFarkop} title={"Наши партнеры"} />
              {isFarkop && <News title={"Последние работы"} />}
            </>
          }
        >
          <div className={styles.Services}>
            {services.map((service) => (
              <Link href={`/services/${service.code}`} key={service.id}>
                <a className={styles.Service}>
                  <div className={styles.Image}>
                    <img
                      src={service.image}
                      alt={service.name}
                      title={service.name}
                    />
                  </div>
                  <div className={styles.Info}>
                    <div className={styles.Name}>{service.name}</div>
                    <div
                      className={styles.Text}
                      dangerouslySetInnerHTML={{
                        __html: service.description,
                      }}
                    ></div>

                    <div className={styles.Bottom}>
                      <Botton
                        onClick={() => {
                          dispatch(
                            showPopup(popupTypes.serviceOrder, service.name),
                          );
                        }}
                        label={"Оставить заявку"}
                      ></Botton>
                      <Botton
                        label={"Подробнее"}
                        type={"outline"}
                        onClick={() => {
                          router.push(`/services/${service.code}`);
                        }}
                      ></Botton>
                    </div>
                  </div>
                </a>
              </Link>
            ))}
            {services.length === 0 && (
              <span>В г.{cityName} нет доступных услуг</span>
            )}
          </div>
        </RightSide>
      )}
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(function (store) {
  return async ({ query, req }) => {
    const reset = Boolean(query.reset);
    const services = await Api.server.getServicesList(req.headers.host, reset);
    await store.dispatch(await fetchRightNews(Redis, reset));
    store.dispatch(addBreadcrumb({ link: "/services/", name: "Услуги" }));

    return pagesWrapper(
      {
        services,
        subDomain: req.headers.host.split(".")[0],
      },
      store,
      Redis,
      {
        req,
        query,
      },
      "/services/",
    );
  };
});
